"use strict";

var _defineProperty = require("/Users/janne/dev/c64jasm-browser/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/Users/janne/dev/c64jasm-browser/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _toConsumableArray = require("/Users/janne/dev/c64jasm-browser/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _createForOfIteratorHelper = require("/Users/janne/dev/c64jasm-browser/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/Users/janne/dev/c64jasm-browser/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/janne/dev/c64jasm-browser/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assemble = exports.platformC64 = void 0;

var opcodes_1 = require("./opcodes");

var path = require("path");

var importFresh = require('import-fresh');

var fs = require("fs");

var util_1 = require("./util");

var ast = require("./ast");

var segment_1 = require("./segment");

var parseCache_1 = require("./parseCache");

var debugInfo_1 = require("./debugInfo");

;

function isJsCallError(e) {
  return e.jsError !== undefined;
}

;
exports.platformC64 = {
  name: 'c64',
  defaultStartPC: 0x801
};
;

function mkErrorValue(v) {
  return {
    value: v,
    errors: true,
    completeFirstPass: false
  };
}

function mkEvalValue(v, complete) {
  return {
    value: v,
    errors: false,
    completeFirstPass: complete
  };
}

function anyErrors() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.some(function (e) {
    return e !== undefined && e.errors;
  });
}

function combineEvalPassInfo() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return args.every(function (e) {
    return e !== undefined && e.completeFirstPass;
  });
}

var NamedScope = /*#__PURE__*/function () {
  function NamedScope(parent, name) {
    _classCallCheck(this, NamedScope);

    this.syms = new Map();
    this.parent = null;
    this.children = new Map();
    this.parent = parent;
    this.name = name;
  }

  _createClass(NamedScope, [{
    key: "newScope",
    value: function newScope(name, parent) {
      var s = this.children.get(name);

      if (s !== undefined) {
        return s;
      }

      var newScope = new NamedScope(parent, name);
      this.children.set(name, newScope);
      return newScope;
    }
  }, {
    key: "findSymbol",
    value: function findSymbol(name) {
      for (var cur = this; cur !== null; cur = cur.parent) {
        var n = cur.syms.get(name);

        if (n !== undefined) {
          return n;
        }
      }

      return undefined;
    }
  }, {
    key: "findSymbolPath",
    value: function findSymbolPath(path) {
      if (path.length == 1) {
        return this.findSymbol(path[0]);
      }

      var tab = this;

      while (tab.children.get(path[0]) == undefined) {
        tab = tab.parent;

        if (tab == null) {
          return undefined;
        }
      }

      for (var i = 0; i < path.length - 1; i++) {
        tab = tab.children.get(path[i]);

        if (tab == undefined) {
          return undefined;
        }
      }

      return tab.syms.get(path[path.length - 1]);
    }
  }, {
    key: "addSymbol",
    value: function addSymbol(name, val, pass) {
      this.syms.set(name, Object.assign(Object.assign({}, val), {
        seen: pass
      }));
    }
  }, {
    key: "updateSymbol",
    value: function updateSymbol(name, val, pass) {
      for (var cur = this; cur !== null; cur = cur.parent) {
        var v = cur.syms.get(name);

        if (v !== undefined) {
          cur.syms.set(name, Object.assign(Object.assign({}, val), {
            seen: pass
          }));
          return;
        }
      }
    }
  }]);

  return NamedScope;
}();

var Scopes = /*#__PURE__*/function () {
  function Scopes() {
    _classCallCheck(this, Scopes);

    this.passCount = 0;
    this.root = new NamedScope(null, '');
    this.curSymtab = this.root;
    this.anonScopeCount = 0;
  }

  _createClass(Scopes, [{
    key: "startPass",
    value: function startPass(pass) {
      this.curSymtab = this.root;
      this.anonScopeCount = 0;
      this.passCount = pass;
    }
  }, {
    key: "withAnonScope",
    value: function withAnonScope(body, parent) {
      var anonLabel = "__anon_scope_".concat(this.anonScopeCount);
      this.anonScopeCount++;
      this.withLabelScope(anonLabel, body, parent);
    }
  }, {
    key: "withLabelScope",
    value: function withLabelScope(name, body, parent) {
      var curSym = this.curSymtab;
      this.curSymtab = this.curSymtab.newScope(name, parent || curSym);
      body();
      this.curSymtab = curSym;
    }
  }, {
    key: "findPath",
    value: function findPath(path, absolute) {
      if (absolute) {
        return this.root.findSymbolPath(path);
      }

      return this.curSymtab.findSymbolPath(path);
    }
  }, {
    key: "findQualifiedSym",
    value: function findQualifiedSym(path, absolute) {
      return this.findPath(path, absolute);
    }
  }, {
    key: "symbolSeen",
    value: function symbolSeen(name) {
      var n = this.curSymtab.syms.get(name);

      if (n !== undefined) {
        return n.seen == this.passCount;
      }

      return false;
    }
  }, {
    key: "declareLabelSymbol",
    value: function declareLabelSymbol(symbol, codePC, segment) {
      var name = symbol.name,
          loc = symbol.loc;
      var prevLabel = this.curSymtab.syms.get(name);

      if (prevLabel === undefined) {
        var lblsym = {
          type: 'label',
          segment: segment,
          data: mkEvalValue({
            addr: codePC,
            loc: loc
          }, false)
        };
        this.curSymtab.addSymbol(name, lblsym, this.passCount);
        return false;
      }

      if (prevLabel.type !== 'label') {
        throw new Error('ICE: declareLabelSymbol should be called only on labels');
      }

      var lbl = prevLabel;

      if (lbl.data.value.addr !== codePC) {
        var newSymValue = {
          type: 'label',
          segment: segment,
          data: Object.assign(Object.assign({}, prevLabel.data), {
            value: Object.assign(Object.assign({}, prevLabel.data.value), {
              addr: codePC
            })
          })
        };
        this.curSymtab.updateSymbol(name, newSymValue, this.passCount);
        return true;
      }

      this.curSymtab.updateSymbol(name, prevLabel, this.passCount);
      return false;
    }
  }, {
    key: "declareVar",
    value: function declareVar(name, value) {
      this.curSymtab.addSymbol(name, {
        type: 'var',
        data: value
      }, this.passCount);
    }
  }, {
    key: "updateVar",
    value: function updateVar(symbolName, val) {
      var newVar = {
        type: 'var',
        data: val
      };
      this.curSymtab.updateSymbol(symbolName, newVar, this.passCount);
    }
  }, {
    key: "declareSegment",
    value: function declareSegment(name, seg) {
      this.curSymtab.addSymbol(name, {
        type: 'segment',
        data: seg
      }, this.passCount);
    }
  }, {
    key: "findMacro",
    value: function findMacro(path, absolute) {
      var sym = this.findPath(path, absolute);

      if (sym !== undefined && sym.type == 'macro') {
        return sym;
      }

      return undefined;
    }
  }, {
    key: "declareMacro",
    value: function declareMacro(name, value) {
      this.curSymtab.addSymbol(name, {
        type: 'macro',
        macro: value,
        declaredIn: this.curSymtab
      }, this.passCount);
    }
  }, {
    key: "dumpLabels",
    value: function dumpLabels(codePC, segments) {
      var segmentToName = {};

      var _iterator = _createForOfIteratorHelper(segments),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
              n = _step$value[0],
              _s = _step$value[1];

          segmentToName[_s.id] = n;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var stack = [];

      var pushScope = function pushScope(path, sym) {
        if (path !== undefined) {
          var newPath = [].concat(_toConsumableArray(path), [sym.name]);
          stack.push({
            path: newPath,
            sym: sym
          });
        } else {
          stack.push({
            path: [],
            sym: sym
          });
        }
      };

      pushScope(undefined, this.root);
      var labels = [];

      while (stack.length > 0) {
        var s = stack.pop();

        var _iterator2 = _createForOfIteratorHelper(s.sym.syms),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _step2$value = _slicedToArray(_step2.value, 2),
                k = _step2$value[0],
                lbl = _step2$value[1];

            if (lbl.type == 'label') {
              labels.push({
                path: [].concat(_toConsumableArray(s.path), [k]),
                addr: lbl.data.value.addr,
                size: 0,
                segmentName: segmentToName[lbl.segment.id]
              });
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        var _iterator3 = _createForOfIteratorHelper(s.sym.children),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _step3$value = _slicedToArray(_step3.value, 2),
                _k = _step3$value[0],
                sym = _step3$value[1];

            pushScope(s.path, sym);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }

      var sortedLabels = labels.sort(function (a, b) {
        return a.addr - b.addr;
      });
      var numLabels = sortedLabels.length;

      if (numLabels > 0) {
        for (var i = 1; i < numLabels; i++) {
          sortedLabels[i - 1].size = sortedLabels[i].addr - sortedLabels[i - 1].addr;
        }

        var last = sortedLabels[numLabels - 1];
        last.size = codePC - last.addr;
      }

      return sortedLabels.map(function (_ref) {
        var path = _ref.path,
            addr = _ref.addr,
            size = _ref.size,
            segmentName = _ref.segmentName;
        return {
          name: path.join('::'),
          addr: addr,
          size: size,
          segmentName: segmentName
        };
      });
    }
  }]);

  return Scopes;
}();

function isTrueVal(cond) {
  return cond === true || cond != 0;
}

function makeCompileLoc(filename) {
  return {
    source: filename,
    start: {
      offset: 0,
      line: 0,
      column: 0
    },
    end: {
      offset: 0,
      line: 0,
      column: 0
    }
  };
}

function formatTypename(v) {
  var typeName = typeof v;

  if (typeName === 'object') {
    if (v instanceof Array) {
      return 'array';
    }
  }

  return typeName;
}

function formatSymbolPath(p) {
  return "".concat(p.absolute ? '::' : '').concat(p.path.join('::'));
}

var runBinop = function runBinop(a, b, f) {
  var res = f(a.value, b.value);
  var firstPassComplete = combineEvalPassInfo(a, b);

  if (typeof res == 'boolean') {
    return mkEvalValue(res ? 1 : 0, firstPassComplete);
  }

  return mkEvalValue(res, firstPassComplete);
};

var runUnaryOp = function runUnaryOp(a, f) {
  if (anyErrors(a)) {
    return mkErrorValue(0);
  }

  var res = f(a.value);

  if (typeof res == 'boolean') {
    return mkEvalValue(res ? 1 : 0, a.completeFirstPass);
  }

  return mkEvalValue(res, a.completeFirstPass);
};

var isRunningNodeJS = typeof process !== 'undefined' && process.versions != null && process.versions.node != null;

function browserRequire(code) {
  var module = {
    exports: {}
  };
  var wrapper = Function("module", code.toString());
  wrapper(module);
  return module.exports;
}

var Assembler = /*#__PURE__*/function () {
  function Assembler(options) {
    var _this = this;

    _classCallCheck(this, Assembler);

    this.parseCache = new parseCache_1.default();
    this.pluginCache = new Map();
    this.includeStack = [];
    this.curSegmentName = '';
    this.curSegment = new segment_1.Segment(0, 0, false, 0);
    this.pass = 0;
    this.needPass = false;
    this.scopes = new Scopes();
    this.segments = [];
    this.errorList = [];
    this.warningList = [];
    this.outOfRangeBranches = [];
    this.debugInfo = new debugInfo_1.DebugInfoTracker();

    this.errors = function () {
      return _this.formatErrors(_this.errorList, 'error');
    };

    this.warnings = function () {
      return _this.formatErrors(_this.warningList, 'warning');
    };

    this.readFileSyncFunc = options.readFileSync;
    this.platform = options.platformOptions || exports.platformC64;
  }

  _createClass(Assembler, [{
    key: "readFileSync",
    value: function readFileSync(filename, options) {
      return this.readFileSyncFunc(filename, options);
    }
  }, {
    key: "prg",
    value: function prg() {
      var _segment_1$mergeSegme = segment_1.mergeSegments(this.segments),
          startPC = _segment_1$mergeSegme.startPC,
          binary = _segment_1$mergeSegme.binary;

      var startLo = startPC & 255;
      var startHi = startPC >> 8 & 255;
      return Buffer.concat([Buffer.from([startLo, startHi]), binary]);
    }
  }, {
    key: "parse",
    value: function parse(filename, loc) {
      var _this2 = this;

      var l = loc == undefined ? makeCompileLoc(filename) : loc;
      return this.parseCache.parse(filename, loc, function (fname, _loc) {
        return _this2.guardedReadFileSync(fname, l);
      });
    }
  }, {
    key: "addJSStackErrors",
    value: function addJSStackErrors(err, loc) {
      if (err.stack) {
        var lines = err.stack.split('\n');

        if (lines.length > 0) {
          var m = lines[0].match(/(.*):(\d+)/);

          if (m) {
            var jsSource = m[1];
            var line = m[2];
            var rel = path.relative(path.dirname(loc.source), jsSource);
            var r = this.makeSourceRelativePath(rel);
            var _err = null;

            for (var i = 1; i < lines.length; i++) {
              var _m = lines[i].match(/^([a-zA-Z]*Error:.*)/);

              if (_m) {
                _err = _m[1];
              }
            }

            var jsLoc = {
              start: {
                offset: -1,
                line: line,
                column: 1
              },
              end: {
                offset: -1,
                line: line,
                column: 2
              },
              source: r
            };
            this.addError("".concat(_err !== null && _err !== void 0 ? _err : 'null'), jsLoc);
          } else if (lines.length >= 2) {
            var m0 = lines[0].match(/^([a-zA-Z]*Error:.*)/);
            var m1 = lines[1].match(/^\s*at\s+.+\s+\((.+):(\d+):(\d+)\)/);

            if (m0 && m1) {
              var _err2 = m0[1];
              var _jsSource = m1[1];
              var _line = m1[2];
              var col = m1[3];

              var _rel = path.relative(path.dirname(loc.source), _jsSource);

              var source = this.makeSourceRelativePath(_rel);
              var _jsLoc = {
                start: {
                  offset: -1,
                  line: _line,
                  column: col
                },
                end: {
                  offset: -1,
                  line: _line,
                  column: col
                },
                source: source
              };
              this.addError("".concat(_err2), _jsLoc);
            }
          }
        }
      }
    }
  }, {
    key: "requirePlugin",
    value: function requirePlugin(fname, loc) {
      var p = this.pluginCache.get(fname);

      if (p !== undefined) {
        return p;
      }

      var sourceRelativePath = this.makeSourceRelativePath(fname);

      try {
        var newPlugin = undefined;

        if (isRunningNodeJS) {
          newPlugin = importFresh(path.resolve(sourceRelativePath));
        } else {
          var source = this.guardedReadFileSync("".concat(sourceRelativePath, ".js"), loc);

          if (source !== undefined) {
            newPlugin = browserRequire(source);
          }
        }

        if (newPlugin === undefined) {
          return mkErrorValue(0);
        }

        var m = mkEvalValue(newPlugin, true);
        this.pluginCache.set(fname, m);
        return m;
      } catch (err) {
        this.addError("Plugin load failed: ".concat(sourceRelativePath, ".js: ").concat(err.message), loc);
        this.addJSStackErrors(err, loc);
        return mkErrorValue(0);
      }
    }
  }, {
    key: "peekSourceStack",
    value: function peekSourceStack() {
      var len = this.includeStack.length;
      return this.includeStack[len - 1];
    }
  }, {
    key: "pushSource",
    value: function pushSource(fname) {
      this.includeStack.push(fname);
    }
  }, {
    key: "popSource",
    value: function popSource() {
      this.includeStack.pop();
    }
  }, {
    key: "anyErrors",
    value: function anyErrors() {
      return this.errorList.length !== 0;
    }
  }, {
    key: "formatErrors",
    value: function formatErrors(diags, errType) {
      var set = new Set(diags.map(function (v) {
        return JSON.stringify(v);
      }));
      return _toConsumableArray(set).map(function (errJson) {
        var _JSON$parse = JSON.parse(errJson),
            loc = _JSON$parse.loc,
            msg = _JSON$parse.msg;

        var formatted = "<unknown>:1:1: ".concat(errType, ": ").concat(msg);

        if (loc) {
          formatted = "".concat(loc.source, ":").concat(loc.start.line, ":").concat(loc.start.column, ": ").concat(errType, ": ").concat(msg);
        }

        return {
          loc: loc,
          msg: msg,
          formatted: formatted
        };
      });
    }
  }, {
    key: "addError",
    value: function addError(msg, loc) {
      this.errorList.push({
        msg: msg,
        loc: loc
      });
    }
  }, {
    key: "addWarning",
    value: function addWarning(msg, loc) {
      this.warningList.push({
        msg: msg,
        loc: loc
      });
    }
  }, {
    key: "startPass",
    value: function startPass(pass) {
      this.pass = pass;
      this.needPass = false;
      this.errorList = [];
      this.scopes.startPass(pass);
      this.outOfRangeBranches = [];
      this.debugInfo = new debugInfo_1.DebugInfoTracker();
      this.segments = [];
      var segment = this.newSegment('default', this.platform.defaultStartPC, undefined, true);
      this.setCurrentSegment({
        type: 'segment',
        data: segment
      }, 'default');
      this.scopes.declareSegment('default', this.curSegment);
    }
  }, {
    key: "setCurrentSegment",
    value: function setCurrentSegment(sym, segmentName) {
      this.curSegmentName = segmentName;
      this.curSegment = sym.data;
    }
  }, {
    key: "newSegment",
    value: function newSegment(name, startAddr, endAddr, inferStart) {
      var segment = new segment_1.Segment(startAddr, endAddr, inferStart, this.segments.length - 1);

      for (var i = 1; i < this.segments.length; i++) {
        var _this$segments$i = _slicedToArray(this.segments[i], 2),
            n = _this$segments$i[0],
            s = _this$segments$i[1];

        if (this.segments[i][1].overlaps(segment)) {
          this.addError("Segment '".concat(name, "' (range: ").concat(segment.formatRange(), " overlaps with an earlier segment '").concat(n, "' (range: ").concat(s.formatRange(), ")"), this.lineLoc);
        }
      }

      this.segments.push([name, segment]);
      return segment;
    }
  }, {
    key: "getPC",
    value: function getPC() {
      return this.curSegment.currentPC();
    }
  }, {
    key: "emitBasicHeader",
    value: function emitBasicHeader() {
      var _this3 = this;

      this.emit(0x0c);
      this.emit(0x08);
      this.emit(0x00);
      this.emit(0x00);
      this.emit(0x9e);
      var addr = 0x80d;
      var dividers = [10000, 1000, 100, 10, 1];
      dividers.forEach(function (div) {
        if (addr >= div) {
          _this3.emit(0x30 + addr / div % 10);
        }
      });
      this.emit(0);
      this.emit(0);
      this.emit(0);
    }
  }, {
    key: "emitBinary",
    value: function emitBinary(ast) {
      var kwargs = ast.kwargs;

      var _this$evalKwargToStri = this.evalKwargToString(kwargs, 'file', ast.loc),
          _this$evalKwargToStri2 = _slicedToArray(_this$evalKwargToStri, 2),
          evalFname = _this$evalKwargToStri2[0],
          fnameLoc = _this$evalKwargToStri2[1];

      var _this$evalKwargToIntM = this.evalKwargToIntMaybe(kwargs, 'size', ast.loc),
          _this$evalKwargToIntM2 = _slicedToArray(_this$evalKwargToIntM, 2),
          sizeEv = _this$evalKwargToIntM2[0],
          sizeLoc = _this$evalKwargToIntM2[1];

      var _this$evalKwargToIntM3 = this.evalKwargToIntMaybe(kwargs, 'offset', ast.loc),
          _this$evalKwargToIntM4 = _slicedToArray(_this$evalKwargToIntM3, 2),
          offsetEv = _this$evalKwargToIntM4[0],
          offsetLoc = _this$evalKwargToIntM4[1];

      var size = sizeEv;
      var offset = offsetEv !== null && offsetEv !== void 0 ? offsetEv : mkEvalValue(0, true);
      var kwargsOK = this.validateKwargs(kwargs, ['file', 'size', 'offset']);

      if (anyErrors(evalFname, offset, size !== null && size !== void 0 ? size : undefined) || !kwargsOK) {
        return;
      }

      if (!offset.completeFirstPass) {
        this.addError("!binary 'offset' must evaluate to a value in the first pass", offsetLoc);
      }

      if (size !== null && !size.completeFirstPass) {
        this.addError("!binary 'size' must evaluate to a value in the first pass", sizeLoc);
      }

      var fname = this.makeSourceRelativePath(evalFname.value);
      var buf = this.guardedReadFileSync(fname, ast.loc);

      if (buf === undefined) {
        return;
      }

      var numBytes = size !== null ? size.value : buf.byteLength;
      var truncated = buf.slice(offset.value, offset.value + numBytes);

      var _iterator4 = _createForOfIteratorHelper(truncated),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var b = _step4.value;
          this.emit(b);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, {
    key: "evalExprType",
    value: function evalExprType(node, ty, msg) {
      var res = this.evalExpr(node);
      var errors = res.errors,
          value = res.value,
          completeFirstPass = res.completeFirstPass;

      if (!errors && typeof value !== ty) {
        this.addError("Expecting ".concat(msg, " to be '").concat(ty, "' type, got '").concat(formatTypename(value), "'"), node.loc);
        return {
          errors: true,
          completeFirstPass: completeFirstPass,
          value: value
        };
      }

      return res;
    }
  }, {
    key: "evalKwargType",
    value: function evalKwargType(kwargs, argName, ty, loc) {
      var _iterator5 = _createForOfIteratorHelper(kwargs),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var a = _step5.value;

          if (a.name.name === argName) {
            var ev = this.evalExprType(a.value, ty, "keyword arg '".concat(argName, "'"));
            return [ev, a.loc];
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      this.addError("Missing required keyword arg '".concat(argName, "'"), loc);
      return [mkErrorValue(0), loc];
    }
  }, {
    key: "evalKwargTypeMaybe",
    value: function evalKwargTypeMaybe(kwargs, argName, ty, loc) {
      var _iterator6 = _createForOfIteratorHelper(kwargs),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var a = _step6.value;

          if (a.name.name === argName) {
            var ev = this.evalExprType(a.value, ty, "keyword arg '".concat(argName, "'"));
            return [ev, a.loc];
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      return [null, loc];
    }
  }, {
    key: "validateKwargs",
    value: function validateKwargs(kwargs, knownArgs) {
      var ok = true;
      var argHisto = {};

      var _iterator7 = _createForOfIteratorHelper(kwargs),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var a = _step7.value;
          var n = a.name.name;

          if (argHisto[n] === undefined) {
            argHisto[n] = 1;
          } else {
            argHisto[n] += 1;
          }

          if (argHisto[n] > 1) {
            this.addError("Duplicate keyword arg '".concat(n, "'"), a.loc);
            ok = false;
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      var _iterator8 = _createForOfIteratorHelper(kwargs),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var _a = _step8.value;

          if (knownArgs.indexOf(_a.name.name) < 0) {
            this.addError("Unexpected keyword arg '".concat(_a.name.name, "'"), _a.loc);
            ok = false;
          }
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }

      return ok;
    }
  }, {
    key: "evalExprToInt",
    value: function evalExprToInt(node, msg) {
      return this.evalExprType(node, 'number', msg);
    }
  }, {
    key: "evalExprToString",
    value: function evalExprToString(node, msg) {
      return this.evalExprType(node, 'string', msg);
    }
  }, {
    key: "evalKwargToInt",
    value: function evalKwargToInt(kwargs, argName, loc) {
      return this.evalKwargType(kwargs, argName, 'number', loc);
    }
  }, {
    key: "evalKwargToString",
    value: function evalKwargToString(kwargs, argName, loc) {
      return this.evalKwargType(kwargs, argName, 'string', loc);
    }
  }, {
    key: "evalKwargToIntMaybe",
    value: function evalKwargToIntMaybe(kwargs, argName, loc) {
      return this.evalKwargTypeMaybe(kwargs, argName, 'number', loc);
    }
  }, {
    key: "evalExpr",
    value: function evalExpr(node) {
      var _this4 = this;

      switch (node.type) {
        case 'binary':
          {
            var left = this.evalExpr(node.left);
            var right = this.evalExpr(node.right);

            if (anyErrors(left, right)) {
              return mkErrorValue(0);
            }

            if (typeof left.value !== typeof right.value) {
              this.addError("Binary expression operands are expected to be of the same type.  Got: '".concat(formatTypename(left.value), "' (left), '").concat(formatTypename(right.value), "' (right)"), node.loc);
              return mkErrorValue(0);
            }

            if (typeof left.value !== 'string' && typeof left.value !== 'number') {
              this.addError("Binary expression operands can only operator on numbers or strings.  Got: '".concat(formatTypename(left.value), "'"), node.loc);
              return mkErrorValue(0);
            }

            if (typeof left.value == 'string') {
              var okOps = ['+', '==', '<', '<=', '>', '>='];

              if (okOps.indexOf(node.op) < 0) {
                this.addError("'".concat(node.op, "' operator is not supported for strings.  Valid operators for strings are: ").concat(okOps.join(', ')), node.loc);
                return mkErrorValue(0);
              }
            }

            switch (node.op) {
              case '+':
                return runBinop(left, right, function (a, b) {
                  return a + b;
                });

              case '-':
                return runBinop(left, right, function (a, b) {
                  return a - b;
                });

              case '*':
                return runBinop(left, right, function (a, b) {
                  return a * b;
                });

              case '/':
                return runBinop(left, right, function (a, b) {
                  return a / b;
                });

              case '%':
                return runBinop(left, right, function (a, b) {
                  return a % b;
                });

              case '&':
                return runBinop(left, right, function (a, b) {
                  return a & b;
                });

              case '|':
                return runBinop(left, right, function (a, b) {
                  return a | b;
                });

              case '^':
                return runBinop(left, right, function (a, b) {
                  return a ^ b;
                });

              case '<<':
                return runBinop(left, right, function (a, b) {
                  return a << b;
                });

              case '>>':
                return runBinop(left, right, function (a, b) {
                  return a >> b;
                });

              case '==':
                return runBinop(left, right, function (a, b) {
                  return a == b;
                });

              case '!=':
                return runBinop(left, right, function (a, b) {
                  return a != b;
                });

              case '<':
                return runBinop(left, right, function (a, b) {
                  return a < b;
                });

              case '<=':
                return runBinop(left, right, function (a, b) {
                  return a <= b;
                });

              case '>':
                return runBinop(left, right, function (a, b) {
                  return a > b;
                });

              case '>=':
                return runBinop(left, right, function (a, b) {
                  return a >= b;
                });

              case '&&':
                return runBinop(left, right, function (a, b) {
                  return a && b;
                });

              case '||':
                return runBinop(left, right, function (a, b) {
                  return a || b;
                });

              default:
                throw new Error("Unhandled binary operator ".concat(node.op));
            }
          }

        case 'unary':
          {
            var v = this.evalExprToInt(node.expr, 'operand');

            if (v.errors) {
              return v;
            }

            switch (node.op) {
              case '+':
                return runUnaryOp(v, function (v) {
                  return +v;
                });

              case '-':
                return runUnaryOp(v, function (v) {
                  return -v;
                });

              case '~':
                return runUnaryOp(v, function (v) {
                  return ~v;
                });

              default:
                throw new Error("Unhandled unary operator ".concat(node.op));
            }
          }

        case 'literal':
          {
            return mkEvalValue(node.lit, true);
          }

        case 'array':
          {
            var evals = node.list.map(function (v) {
              return _this4.evalExpr(v);
            });
            return {
              value: evals.map(function (e) {
                return e.value;
              }),
              errors: anyErrors.apply(void 0, _toConsumableArray(evals)),
              completeFirstPass: combineEvalPassInfo.apply(void 0, _toConsumableArray(evals))
            };
          }

        case 'object':
          {
            var kvs = node.props.map(function (p) {
              var v = _this4.evalExpr(p.val);

              return [p.key.type === 'literal' ? p.key.lit : p.key.name, v];
            });
            return {
              value: kvs.reduce(function (o, _ref2) {
                var _ref3 = _slicedToArray(_ref2, 2),
                    key = _ref3[0],
                    value = _ref3[1];

                return Object.assign(Object.assign({}, o), _defineProperty({}, key, value.value));
              }, {}),
              errors: anyErrors.apply(void 0, _toConsumableArray(kvs.map(function (_ref4) {
                var _ref5 = _slicedToArray(_ref4, 2),
                    _ = _ref5[0],
                    e = _ref5[1];

                return e;
              }))),
              completeFirstPass: combineEvalPassInfo.apply(void 0, _toConsumableArray(kvs.map(function (_ref6) {
                var _ref7 = _slicedToArray(_ref6, 2),
                    _ = _ref7[0],
                    e = _ref7[1];

                return e;
              })))
            };
          }

        case 'ident':
          {
            throw new Error('should not see an ident here -- if you do, it is probably a wrong type node in parser');
          }

        case 'qualified-ident':
          {
            var sym = this.scopes.findQualifiedSym(node.path, node.absolute);

            if (sym == undefined) {
              if (this.pass >= 1) {
                this.addError("Undefined symbol '".concat(formatSymbolPath(node), "'"), node.loc);
                return mkErrorValue(0);
              }

              this.needPass = true;
              return mkEvalValue(0, false);
            }

            switch (sym.type) {
              case 'label':
                return {
                  errors: sym.data.errors,
                  value: sym.data.value.addr,
                  completeFirstPass: sym.seen == this.pass
                };

              case 'var':
                if (sym.seen < this.pass) {
                  this.addError("Undeclared variable '".concat(formatSymbolPath(node), "'"), node.loc);
                }

                return sym.data;

              case 'macro':
              case 'segment':
                this.addError("Must have a label or a variable identifier here, got ".concat(sym.type, " name"), node.loc);
                return mkErrorValue(0);
            }

            break;
          }

        case 'member':
          {
            var evaledObject = this.evalExpr(node.object);

            if (anyErrors(evaledObject)) {
              return mkErrorValue(0);
            }

            var object = evaledObject.value;

            if (object == undefined) {
              this.addError("Cannot access properties of an undefined object", node.loc);
              return mkErrorValue(0);
            }

            var checkProp = function checkProp(prop, loc) {
              if (!(prop in object)) {
                _this4.addError("Property '".concat(prop, "' does not exist in object"), loc);

                return false;
              }

              return true;
            };

            var evalProperty = function evalProperty(node, typeName) {
              if (node.property.type !== 'ident') {
                _this4.addError("".concat(typeName, " property must be a string, got ").concat(formatTypename(node.property.type)), node.loc);
              } else {
                if (checkProp(node.property.name, node.property.loc)) {
                  return mkEvalValue(object[node.property.name], evaledObject.completeFirstPass);
                }
              }

              return mkErrorValue(0);
            };

            if (object instanceof Array) {
              if (!node.computed) {
                return evalProperty(node, 'Array');
              }

              var _this$evalExprToInt = this.evalExprToInt(node.property, 'array index'),
                  errors = _this$evalExprToInt.errors,
                  idx = _this$evalExprToInt.value,
                  completeFirstPass = _this$evalExprToInt.completeFirstPass;

              if (errors) {
                return mkErrorValue(0);
              }

              if (!(idx in object)) {
                this.addError("Out of bounds array index ".concat(idx), node.property.loc);
                return mkErrorValue(0);
              }

              return mkEvalValue(object[idx], evaledObject.completeFirstPass && completeFirstPass);
            } else if (typeof object == 'object') {
              if (!node.computed) {
                return evalProperty(node, 'Object');
              } else {
                var _this$evalExpr = this.evalExpr(node.property),
                    _errors = _this$evalExpr.errors,
                    prop = _this$evalExpr.value,
                    _completeFirstPass = _this$evalExpr.completeFirstPass;

                if (_errors) {
                  return mkErrorValue(0);
                }

                if (typeof prop !== 'string' && typeof prop !== 'number') {
                  this.addError("Object property must be a string or an integer, got ".concat(formatTypename(prop)), node.loc);
                  return mkErrorValue(0);
                }

                if (checkProp(prop, node.property.loc)) {
                  return mkEvalValue(object[prop], _completeFirstPass && evaledObject.completeFirstPass);
                }

                return mkErrorValue(0);
              }
            }

            if (this.pass !== 0) {
              if (!evaledObject.errors) {
                if (node.computed) {
                  this.addError("Cannot use []-operator on non-array/object values", node.loc);
                } else {
                  this.addError("Cannot use the dot-operator on non-object values", node.loc);
                }
              }

              return mkErrorValue(0);
            }

            return mkEvalValue(0, false);
          }

        case 'callfunc':
          {
            var callee = this.evalExpr(node.callee);
            var argValues = node.args.map(function (expr) {
              return _this4.evalExpr(expr);
            });

            if (callee.errors) {
              return mkErrorValue(0);
            }

            if (typeof callee.value !== 'function') {
              this.addError("Callee must be a function type.  Got '".concat(formatTypename(callee), "'"), node.loc);
              return mkErrorValue(0);
            }

            if (anyErrors.apply(void 0, _toConsumableArray(argValues))) {
              return mkErrorValue(0);
            }

            try {
              var complete = callee.completeFirstPass && combineEvalPassInfo.apply(void 0, _toConsumableArray(argValues));
              return mkEvalValue(callee.value.apply(callee, _toConsumableArray(argValues.map(function (v) {
                return v.value;
              }))), complete);
            } catch (err) {
              if (node.callee.type == 'qualified-ident') {
                this.addError("Call to '".concat(formatSymbolPath(node.callee), "' failed with an error: ").concat(err.message), node.loc);
              } else {
                this.addError("Plugin call failed with an error: ".concat(err.message), node.loc);
              }

              if (isJsCallError(err)) {
                this.addJSStackErrors(err, node.loc);
              }

              return mkErrorValue(0);
            }
          }

        case 'getcurpc':
          {
            return mkEvalValue(this.getPC(), true);
          }

        default:
          break;
      }

      throw new Error('should be unreachable?');
      return mkErrorValue(0);
    }
  }, {
    key: "topLevelSourceLoc",
    value: function topLevelSourceLoc() {
      var topFilename = this.includeStack[0];
      return makeCompileLoc(topFilename);
    }
  }, {
    key: "emit",
    value: function emit(byte) {
      var err = this.curSegment.emit(byte);

      if (err !== undefined) {
        this.addError(err, this.lineLoc);
      }
    }
  }, {
    key: "emit16",
    value: function emit16(word) {
      this.emit(word & 0xff);
      this.emit(word >> 8 & 0xff);
    }
  }, {
    key: "checkSingle",
    value: function checkSingle(opcode) {
      if (opcode === null) {
        return false;
      }

      this.emit(opcode);
      return true;
    }
  }, {
    key: "checkImm",
    value: function checkImm(param, opcode) {
      if (opcode === null || param === null) {
        return false;
      }

      var ev = this.evalExprToInt(param, 'immediate');

      if (!anyErrors(ev)) {
        this.emit(opcode);
        this.emit(ev.value);
      }

      return true;
    }
  }, {
    key: "checkAbs",
    value: function checkAbs(param, opcode, bits) {
      if (opcode === null || param === null) {
        return false;
      }

      var ev = this.evalExprToInt(param, 'absolute address');

      if (anyErrors(ev)) {
        return true;
      }

      var v = ev.value;

      if (bits === 8) {
        if (v < 0 || v >= 1 << bits) {
          return false;
        }

        this.emit(opcode);
        this.emit(v);
      } else {
        this.emit(opcode);
        this.emit16(v);
      }

      return true;
    }
  }, {
    key: "checkBranch",
    value: function checkBranch(param, opcode) {
      if (opcode === null || param === null) {
        return false;
      }

      var ev = this.evalExpr(param);

      if (anyErrors(ev)) {
        return true;
      }

      if (typeof ev.value !== 'number') {
        this.addError("Expecting branch label to evaluate to integer, got ".concat(formatTypename(ev.value)), param.loc);
        return true;
      }

      var addr = ev.value;
      var addrDelta = addr - this.getPC() - 2;
      this.emit(opcode);

      if (addrDelta > 0x7f || addrDelta < -128) {
        this.outOfRangeBranches.push({
          loc: param.loc,
          offset: addrDelta
        });
      }

      this.emit(addrDelta & 0xff);
      return true;
    }
  }, {
    key: "handleSetPC",
    value: function handleSetPC(valueExpr) {
      var ev = this.evalExprToInt(valueExpr, 'pc');

      if (!anyErrors(ev)) {
        var v = ev.value,
            completeFirstPass = ev.completeFirstPass;

        if (!completeFirstPass) {
          this.addError('Value for new program counter must evaluate to a value in the first pass', valueExpr.loc);
          return;
        }

        if (!this.curSegment.empty() && this.curSegment.currentPC() > v) {
          this.addError("Cannot set program counter to a smaller value than current (current: $".concat(util_1.toHex16(this.curSegment.currentPC()), ", trying to set $").concat(util_1.toHex16(v), ")"), valueExpr.loc);
        }

        var err = this.curSegment.setCurrentPC(v);

        if (err !== undefined) {
          this.addError(err, valueExpr.loc);
        }
      }
    }
  }, {
    key: "guardedReadFileSync",
    value: function guardedReadFileSync(fname, loc) {
      try {
        return this.readFileSync(fname);
      } catch (err) {
        this.addError("Couldn't open file '".concat(fname, "'"), loc);
        return undefined;
      }
    }
  }, {
    key: "fileInclude",
    value: function fileInclude(inclStmt) {
      var fnVal = this.evalExprToString(inclStmt.filename, '!include filename');

      if (anyErrors(fnVal)) {
        return;
      }

      var v = fnVal.value;
      var fname = this.makeSourceRelativePath(v);
      this.pushSource(fname);
      this.assemble(fname, inclStmt.loc);
      this.popSource();
    }
  }, {
    key: "fillBytes",
    value: function fillBytes(n) {
      var numVals = this.evalExprToInt(n.numBytes, '!fill num_bytes');
      var fillValue = this.evalExprToInt(n.fillValue, '!fill value');

      if (anyErrors(numVals, fillValue)) {
        return;
      }

      var fv = fillValue.value;

      if (fv < 0 || fv >= 256) {
        this.addError("!fill value to repeat must be in 8-bit range, '".concat(fv, "' given"), n.fillValue.loc);
        return;
      }

      var nb = numVals.value;

      if (nb < 0) {
        this.addError("!fill repeat count must be >= 0, got ".concat(nb), n.numBytes.loc);
        return;
      }

      for (var i = 0; i < nb; i++) {
        this.emit(fv);
      }
    }
  }, {
    key: "alignBytes",
    value: function alignBytes(n) {
      var v = this.evalExprToInt(n.alignBytes, 'alignment');

      if (anyErrors(v)) {
        return;
      }

      var nb = v.value;

      if (nb < 1) {
        this.addError("Alignment must be a positive integer, ".concat(nb, " given"), n.alignBytes.loc);
        return;
      }

      if ((nb & nb - 1) != 0) {
        this.addError("Alignment must be a power of two, ".concat(nb, " given"), n.loc);
        return;
      }

      while ((this.getPC() & nb - 1) != 0) {
        this.emit(0);
      }
    }
  }, {
    key: "withAnonScope",
    value: function withAnonScope(name, compileScope, parent) {
      if (name !== null) {
        return this.withLabelScope(name, compileScope, parent);
      }

      this.scopes.withAnonScope(compileScope, parent);
    }
  }, {
    key: "withLabelScope",
    value: function withLabelScope(name, compileScope, parent) {
      this.scopes.withLabelScope(name, compileScope);
    }
  }, {
    key: "emit8or16",
    value: function emit8or16(v, bits) {
      if (bits == 8) {
        this.emit(v);
        return;
      }

      this.emit16(v);
    }
  }, {
    key: "emitData",
    value: function emitData(exprList, bits) {
      for (var i = 0; i < exprList.length; i++) {
        var ee = this.evalExpr(exprList[i]);

        if (anyErrors(ee)) {
          continue;
        }

        var e = ee.value;

        if (typeof e == 'number') {
          this.emit8or16(e, bits);
        } else if (e instanceof Array) {
          var firstErrorIdx = -1;

          for (var _i = 0; _i < e.length; _i++) {
            var byte = typeof e[_i] === 'number' ? e[_i] : 0;
            firstErrorIdx = typeof e[_i] !== 'number' && firstErrorIdx === -1 ? _i : firstErrorIdx;
            this.emit8or16(byte, bits);
          }

          if (firstErrorIdx != -1) {
            this.addError("Cannot emit non-numeric values.  First non-number at index ".concat(firstErrorIdx), exprList[i].loc);
          }
        } else {
          this.addError("Only literal (int constants) or array types can be emitted.  Got ".concat(formatTypename(e)), exprList[i].loc);
        }
      }
    }
  }, {
    key: "makeFunction",
    value: function makeFunction(pluginFunc, loc) {
      var _this5 = this;

      return function () {
        try {
          for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
          }

          var res = pluginFunc.apply(null, [{
            readFileSync: function readFileSync(fname) {
              return _this5.readFileSync(fname);
            },
            resolveRelative: function resolveRelative(fn) {
              return _this5.makeSourceRelativePath(fn);
            }
          }].concat(args));
          return res;
        } catch (err) {
          err.jsError = true;
          throw err;
        }
      };
    }
  }, {
    key: "bindFunction",
    value: function bindFunction(name, pluginModule, loc) {
      this.scopes.declareVar(name.name, mkEvalValue(this.makeFunction(pluginModule, loc), true));
    }
  }, {
    key: "bindPlugin",
    value: function bindPlugin(node, plugin) {
      var moduleName = node.moduleName;

      if (anyErrors(plugin)) {
        this.scopes.declareVar(moduleName.name, mkErrorValue(0));
        return;
      }

      var module = plugin.value;

      if (typeof module == 'function') {
        this.bindFunction(moduleName, module, node.loc);
      }

      if (typeof module == 'object') {
        var moduleObj = {};
        var keys = Object.keys(module);

        for (var ki in keys) {
          var key = keys[ki];
          var val = module[key];

          if (typeof val === 'function') {
            moduleObj[key] = this.makeFunction(val, node.loc);
          } else {
            moduleObj[key] = val;
          }
        }

        this.scopes.declareVar(moduleName.name, mkEvalValue(moduleObj, true));
      }
    }
  }, {
    key: "checkDirectives",
    value: function checkDirectives(node, localScopeName) {
      var _this6 = this;

      switch (node.type) {
        case 'data':
          {
            this.emitData(node.values, node.dataSize === ast.DataSize.Byte ? 8 : 16);
            break;
          }

        case 'fill':
          {
            this.fillBytes(node);
            break;
          }

        case 'align':
          {
            this.alignBytes(node);
            break;
          }

        case 'setpc':
          {
            this.handleSetPC(node.pc);
            break;
          }

        case 'binary':
          {
            this.emitBinary(node);
            break;
          }

        case 'include':
          {
            this.fileInclude(node);
            break;
          }

        case 'error':
          {
            var msg = this.evalExprToString(node.error, 'error message');

            if (!anyErrors(msg)) {
              this.addError(msg.value, node.loc);
              return;
            }

            break;
          }

        case 'if':
          {
            var cases = node.cases,
                elseBranch = node.elseBranch;

            var _loop = function _loop(ci) {
              var _cases$ci = _slicedToArray(cases[ci], 2),
                  condExpr = _cases$ci[0],
                  body = _cases$ci[1];

              var condition = _this6.evalExpr(condExpr);

              if (!anyErrors(condition) && isTrueVal(condition.value)) {
                return {
                  v: _this6.withAnonScope(localScopeName, function () {
                    _this6.assembleLines(body);
                  })
                };
              }
            };

            for (var ci in cases) {
              var _ret = _loop(ci);

              if (typeof _ret === "object") return _ret.v;
            }

            return this.withAnonScope(localScopeName, function () {
              _this6.assembleLines(elseBranch);
            });
            break;
          }

        case 'for':
          {
            var _ret2 = function () {
              var index = node.index,
                  list = node.list,
                  body = node.body,
                  loc = node.loc;

              var lstVal = _this6.evalExpr(list);

              if (anyErrors(lstVal)) {
                return {
                  v: void 0
                };
              }

              var lst = lstVal.value;

              if (!(lst instanceof Array)) {
                _this6.addError("for-loop range must be an array expression (e.g., a range() or an array)", list.loc);

                return {
                  v: void 0
                };
              }

              var _loop2 = function _loop2(i) {
                var scopeName = null;

                if (localScopeName !== null) {
                  scopeName = "".concat(localScopeName, "__").concat(i);
                }

                _this6.withAnonScope(scopeName, function () {
                  _this6.scopes.declareVar(index.name, mkEvalValue(lst[i], lstVal.completeFirstPass));

                  return _this6.assembleLines(body);
                });
              };

              for (var i = 0; i < lst.length; i++) {
                _loop2(i);
              }

              return "break";
            }();

            if (_ret2 === "break") break;
            if (typeof _ret2 === "object") return _ret2.v;
          }

        case 'macro':
          {
            var name = node.name,
                args = node.args,
                body = node.body;
            var prevSym = this.scopes.findQualifiedSym([name.name], false);

            if (prevSym !== undefined && this.scopes.symbolSeen(name.name)) {
              this.addError("Symbol '".concat(name.name, "' already defined"), name.loc);
              return;
            }

            this.scopes.declareMacro(name.name, node);
            break;
          }

        case 'callmacro':
          {
            var _name = node.name,
                _args = node.args;
            var macroSym = this.scopes.findMacro(_name.path, _name.absolute);

            var argValues = _args.map(function (e) {
              return _this6.evalExpr(e);
            });

            if (macroSym == undefined || macroSym.seen < this.pass) {
              this.addError("Undefined macro '".concat(formatSymbolPath(_name), "'"), _name.loc);
              return;
            }

            var macro = macroSym.macro,
                declaredIn = macroSym.declaredIn;

            if (macro.args.length !== _args.length) {
              this.addError("Macro '".concat(formatSymbolPath(_name), "' declared with ").concat(macro.args.length, " args but called here with ").concat(_args.length), _name.loc);
              return;
            }

            this.withAnonScope(localScopeName, function () {
              for (var i = 0; i < argValues.length; i++) {
                var argName = macro.args[i].ident.name;

                _this6.scopes.declareVar(argName, argValues[i]);
              }

              _this6.assembleLines(macro.body);
            }, declaredIn);
            break;
          }

        case 'let':
          {
            var _name2 = node.name;
            var sym = this.scopes.findQualifiedSym([_name2.name], false);
            var eres = this.evalExpr(node.value);

            if (sym !== undefined && this.scopes.symbolSeen(_name2.name)) {
              this.addError("Variable '".concat(_name2.name, "' already defined"), node.loc);
              return;
            }

            this.scopes.declareVar(_name2.name, eres);
            break;
          }

        case 'assign':
          {
            var _name3 = node.name;

            if (node.name.path.length !== 1 || node.name.absolute) {
              this.addError("Only symbol names in the current (or owning) scopes are allowed for assignment", node.loc);
              return;
            }

            var prevValue = this.scopes.findQualifiedSym(node.name.path, node.name.absolute);

            if (prevValue == undefined) {
              this.addError("Assignment to undeclared variable '".concat(formatSymbolPath(_name3), "'"), node.loc);
              return;
            }

            if (prevValue.type !== 'var') {
              this.addError("Assignment to symbol '".concat(formatSymbolPath(_name3), "' that is not a variable.  Its type is '").concat(prevValue.type, "'"), node.loc);
              return;
            }

            var evalValue = this.evalExpr(node.value);
            this.scopes.updateVar(_name3.path[0], evalValue);
            break;
          }

        case 'statement-expr':
          {
            this.evalExpr(node.expr);
            break;
          }

        case 'load-plugin':
          {
            var fname = this.evalExprToString(node.filename, 'plugin filename');

            if (anyErrors(fname)) {
              return;
            }

            var module = this.requirePlugin(fname.value, node.loc);
            this.bindPlugin(node, module);
            break;
          }

        case 'filescope':
          {
            this.addError("The !filescope directive is only allowed as the first directive in a source file", node.loc);
            return;
          }

        case 'declare-segment':
          {
            var _name4 = node.name,
                kwargs = node.kwargs,
                loc = node.loc;

            var _sym = this.scopes.findQualifiedSym([_name4.name], false);

            var _this$evalKwargToInt = this.evalKwargToInt(kwargs, 'start', loc),
                _this$evalKwargToInt2 = _slicedToArray(_this$evalKwargToInt, 2),
                start = _this$evalKwargToInt2[0],
                startLoc = _this$evalKwargToInt2[1];

            var _this$evalKwargToInt3 = this.evalKwargToInt(kwargs, 'end', loc),
                _this$evalKwargToInt4 = _slicedToArray(_this$evalKwargToInt3, 2),
                end = _this$evalKwargToInt4[0],
                endLoc = _this$evalKwargToInt4[1];

            if (_sym !== undefined && this.scopes.symbolSeen(_name4.name)) {
              this.addError("Segment '".concat(_name4.name, "' already defined"), node.loc);
              return;
            }

            var knownArgsOK = this.validateKwargs(kwargs, ['start', 'end']);

            if (anyErrors(start) || anyErrors(end) || !knownArgsOK) {
              return;
            }

            var passErrors = false;

            if (!start.completeFirstPass) {
              this.addError("!segment 'start' must evaluate to a value in the first pass", startLoc);
              passErrors = true;
            }

            if (!end.completeFirstPass) {
              this.addError("!segment 'end' must evaluate to a value in the first pass", endLoc);
              passErrors = true;
            }

            if (passErrors) {
              return;
            }

            var segment = this.newSegment(_name4.name, start.value, end.value, false);
            this.scopes.declareSegment(_name4.name, segment);
            return;
          }

        case 'use-segment':
          {
            var _name5 = node.name,
                _loc2 = node.loc;

            var _sym2 = this.scopes.findQualifiedSym(_name5.path, _name5.absolute);

            if (_sym2 === undefined) {
              this.addError("Use of undeclared segment '".concat(formatSymbolPath(_name5), "'"), _loc2);
              return;
            }

            if (_sym2.type !== 'segment') {
              this.addError("Use of segment '".concat(formatSymbolPath(_name5), "' that is not a declared segment.  Its type is '").concat(_sym2.type, "'"), _loc2);
              return;
            }

            this.setCurrentSegment(_sym2, formatSymbolPath(_name5));
            break;
          }

        case 'break':
          {
            this.debugInfo.markBreak(this.getPC(), this.curSegmentName);
            break;
          }

        default:
          this.addError("unknown directive ".concat(node.type), node.loc);
          return;
      }
    }
  }, {
    key: "assembleLines",
    value: function assembleLines(lst) {
      var _this7 = this;

      if (lst === null || lst.length == 0) {
        return;
      }

      if (lst.length == 0) {
        return;
      }

      var assemble = function assemble(lines) {
        for (var i = 0; i < lines.length; i++) {
          _this7.debugInfo.startLine(lines[i].loc, _this7.getPC(), _this7.curSegment);

          _this7.assembleLine(lines[i]);

          _this7.debugInfo.endLine(_this7.getPC(), _this7.curSegment);
        }
      };

      var firstLine = 0;

      while (firstLine < lst.length) {
        var _lst$firstLine = lst[firstLine],
            label = _lst$firstLine.label,
            stmt = _lst$firstLine.stmt,
            scopedStmts = _lst$firstLine.scopedStmts;

        if (label == null && stmt == null && scopedStmts == null) {
          firstLine++;
        } else {
          break;
        }
      }

      if (firstLine >= lst.length) {
        return;
      }

      var labelScope = lst[firstLine];

      if (labelScope.stmt != null && labelScope.stmt.type == 'filescope') {
        this.checkAndDeclareLabel(labelScope.stmt.name);
        return this.withLabelScope(labelScope.stmt.name.name, function () {
          return assemble(lst.slice(firstLine + 1));
        });
      }

      return assemble(lst);
    }
  }, {
    key: "checkAndDeclareLabel",
    value: function checkAndDeclareLabel(label) {
      if (this.scopes.symbolSeen(label.name)) {
        this.addError("Symbol '".concat(label.name, "' already defined"), label.loc);
      } else {
        var labelChanged = this.scopes.declareLabelSymbol(label, this.getPC(), this.curSegment);

        if (labelChanged) {
          this.needPass = true;
        }
      }
    }
  }, {
    key: "assembleLine",
    value: function assembleLine(line) {
      var _this8 = this;

      this.lineLoc = line.loc;

      if (line.label == null && line.stmt == null && line.scopedStmts == null) {
        return;
      }

      if (line.label !== null) {
        this.checkAndDeclareLabel(line.label);
      }

      var scopedStmts = line.scopedStmts;

      if (scopedStmts != null) {
        if (!line.label) {
          throw new Error('ICE: line.label cannot be undefined');
        }

        this.withLabelScope(line.label.name, function () {
          _this8.assembleLines(scopedStmts);
        });
        return;
      }

      if (line.stmt === null) {
        return;
      }

      if (line.stmt.type !== 'insn') {
        this.checkDirectives(line.stmt, line.label == null ? null : line.label.name);
        return;
      }

      var stmt = line.stmt;
      var insn = stmt.insn;
      var op = opcodes_1.default[insn.mnemonic.toUpperCase()];

      var withMarkAsInsn = function withMarkAsInsn(f) {
        var startPC = _this8.getPC();

        f();

        var endPC = _this8.getPC();

        _this8.debugInfo.markAsInstruction(startPC, endPC);
      };

      if (op !== undefined) {
        withMarkAsInsn(function () {
          var noArgs = insn.imm === null && insn.abs === null && insn.absx === null && insn.absy === null && insn.absind === null;

          if (noArgs && _this8.checkSingle(op[10])) {
            return;
          }

          if (_this8.checkImm(insn.imm, op[0])) {
            return;
          }

          if (_this8.checkAbs(insn.abs, op[1], 8)) {
            return;
          }

          if (_this8.checkAbs(insn.absx, op[2], 8)) {
            return;
          }

          if (_this8.checkAbs(insn.absy, op[3], 8)) {
            return;
          }

          if (_this8.checkAbs(insn.absx, op[5], 16)) {
            return;
          }

          if (_this8.checkAbs(insn.absy, op[6], 16)) {
            return;
          }

          if (_this8.checkAbs(insn.absind, op[7], 16)) {
            return;
          }

          if (_this8.checkAbs(insn.indx, op[8], 8)) {
            return;
          }

          if (_this8.checkAbs(insn.indy, op[9], 8)) {
            return;
          }

          if (_this8.checkAbs(insn.abs, op[4], 16)) {
            return;
          }

          if (_this8.checkBranch(insn.abs, op[11])) {
            return;
          }

          _this8.addError("Couldn't encode instruction '".concat(insn.mnemonic, "'"), line.loc);
        });
      } else {
        this.addError("Unknown mnemonic '".concat(insn.mnemonic, "'"), line.loc);
      }
    }
  }, {
    key: "makeSourceRelativePath",
    value: function makeSourceRelativePath(filename) {
      var curSource = this.peekSourceStack();
      return path.join(path.dirname(curSource), filename);
    }
  }, {
    key: "assemble",
    value: function assemble(filename, loc) {
      try {
        var astLines = this.parse(filename, loc);

        if (astLines !== undefined) {
          this.assembleLines(astLines);
        }
      } catch (err) {
        if ('name' in err && err.name == 'SyntaxError') {
          this.addError("Syntax error: ".concat(err.message), Object.assign(Object.assign({}, err.location), {
            source: this.peekSourceStack()
          }));
        } else if ('name' in err && err.name == 'semantic') {
          return;
        } else {
          throw err;
        }
      }
    }
  }, {
    key: "_requireType",
    value: function _requireType(e, type) {
      if (typeof e == type) {
        return e;
      }

      this.addError("Expecting a ".concat(type, " value, got ").concat(formatTypename(e)), e.loc);
    }
  }, {
    key: "requireString",
    value: function requireString(e) {
      return this._requireType(e, 'string');
    }
  }, {
    key: "requireNumber",
    value: function requireNumber(e) {
      return this._requireType(e, 'number');
    }
  }, {
    key: "registerPlugins",
    value: function registerPlugins() {
      var _this9 = this;

      var json = function json() {
        var name = _this9.requireString(arguments.length <= 0 ? undefined : arguments[0]);

        var fname = _this9.makeSourceRelativePath(name);

        return JSON.parse(_this9.readFileSync(fname, 'utf-8'));
      };

      var range = function range() {
        var start = 0;
        var end = undefined;

        if (arguments.length == 1) {
          end = _this9.requireNumber(arguments.length <= 0 ? undefined : arguments[0]);
        } else if (arguments.length == 2) {
          start = _this9.requireNumber(arguments.length <= 0 ? undefined : arguments[0]);
          end = _this9.requireNumber(arguments.length <= 1 ? undefined : arguments[1]);
        } else {
          throw new Error("Invalid number of args to 'range'.  Expecting 1 or 2 arguments.");
        }

        if (end == start) {
          return [];
        }

        if (end < start) {
          throw new Error("range 'end' must be larger or equal to 'start'");
        }

        return Array(end - start).fill(null).map(function (_, idx) {
          return idx + start;
        });
      };

      var addPlugin = function addPlugin(name, handler) {
        _this9.scopes.declareVar(name, mkEvalValue(handler, false));
      };

      addPlugin('loadJson', json);
      addPlugin('range', range);
      var math = {};

      var _iterator9 = _createForOfIteratorHelper(Object.getOwnPropertyNames(Math)),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var k = _step9.value;
          var props = Math;

          if (k === 'random') {
            math[k] = function () {
              throw new Error('Math.random() not allowed as it will lead to non-reproducible builds');
            };
          } else {
            math[k] = props[k];
          }
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }

      addPlugin('Math', math);
    }
  }, {
    key: "dumpLabels",
    value: function dumpLabels() {
      return this.scopes.dumpLabels(this.getPC(), this.segments);
    }
  }, {
    key: "collectSegmentInfo",
    value: function collectSegmentInfo() {
      return segment_1.collectSegmentInfo(this.segments);
    }
  }]);

  return Assembler;
}();

var defaultOptions = {
  readFileSync: fs.readFileSync
};

function assemble(filename) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOptions;
  var asm = new Assembler(options);
  asm.pushSource(filename);
  var pass = 0;

  do {
    asm.startPass(pass);
    asm.registerPlugins();
    asm.assemble(filename, makeCompileLoc(filename));

    if (pass > 0 && asm.anyErrors()) {
      return {
        prg: Buffer.from([]),
        labels: [],
        segments: [],
        debugInfo: undefined,
        errors: asm.errors(),
        warnings: asm.warnings()
      };
    }

    var maxPass = 10;

    if (pass > maxPass) {
      console.error("Exceeded max pass limit ".concat(maxPass));
      return;
    }

    pass += 1;

    if (!asm.needPass && asm.outOfRangeBranches.length != 0) {
      for (var bidx in asm.outOfRangeBranches) {
        var b = asm.outOfRangeBranches[bidx];
        asm.addError("Branch target too far (must fit in signed 8-bit range, got ".concat(b.offset, ")"), b.loc);
      }

      break;
    }
  } while (asm.needPass);

  asm.popSource();
  return {
    prg: asm.prg(),
    errors: asm.errors(),
    warnings: asm.warnings(),
    labels: asm.dumpLabels(),
    segments: asm.collectSegmentInfo(),
    debugInfo: asm.debugInfo
  };
}

exports.assemble = assemble;